import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";

interface TransactionActionsProps {
  transaction: {
    proof_url?: string;
  };
}

export const TransactionActions = ({ transaction }: TransactionActionsProps) => {
  if (!transaction.proof_url) return null;

  return (
    <Button variant="ghost" size="sm">
      <Eye className="h-4 w-4" />
      Voir la preuve
    </Button>
  );
};